import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import Config from "../Config";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../useAuthhandling';
import Deletemodal from "../Deletemodal";
import Nodatafound from "../Nodatafound";

function SubList() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [servicedata, setServicedata] = useState([]);

  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }


  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=1`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {
      const data = await res.json();

      setServicedata(data.data);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/service-category/delete-service-category/${id}`,
      {
        method: "PUT",

        body: JSON.stringify({
          categoryLevel: 1,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",

          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200 ) {
      const deletedata = await response.json();
      toast.success("Sucessfully deleted", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      getinfo();
    } 
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }
    else {
      console.log("error");

    }
  };
  useEffect(() => {
    getinfo();
  }, []);
  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card" style={{ width: "50%" }}>
                  <div className="card-body">
                    <h4 className="card-title">Service categories(level 1)</h4>
                    <div className="table-responsive pt-3">
                    {servicedata?.length>0?
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Category Name</th>
                            <th>Sub category</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="catlist">
                          {servicedata.map((cat, index) => {
                            return (
                              <tr key={index}>
                                <td>{cat.categoryName}</td>
                                <td>
                                  <Link
                                    to={`/level1/${cat._id}`}
                                    className="levelslink"
                                  >
                                    Sub category
                                  </Link>
                                </td>
                                <td className="actions_td">
                                  <Link
                                    // onClick={() => deleteservice(cat._id)}
                                    onClick={() => tog_animationFlip(cat._id)}
                                    className="margins-2 action_icons"
                                  >
                                    <i className="fa-solid fa-trash" />
                                  </Link>
                               
                                    <Link
                                      to={"/editsubcategory/" + cat._id}
                                      state={{
                                        level: 1,
                                      }}
                                      className="fa-solid fa-pen action_icons"
                                    
                                      
                                    ></Link>
                                   <Link to={"/subcategoryview/" + cat._id} 
                                    state={{
                                     
                                      level: 1,
                                    }}
                                    className="action_icons" >
                                             <i className="fa-solid fa-eye" />
                                             </Link>
                                  
                                  <ToastContainer />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      :
                      <Nodatafound/>
                        }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Level one category"}
          />
        ) : (
          ""
        )}
    </div>
  );
}
export default SubList;
